module.exports = __webpack_public_path__ + "public/img/fenxiao.579db281.png";